import { Alert, Button, Text, VStack } from '@chakra-ui/react';
import { RouterLink } from '@gamma/ui/navigation';
import { ReactNode } from 'react';

export interface NotConfiguredSectionProps {
  header?: ReactNode;
  message: string;
  buttonText?: string;
  buttonLink?: string;
  buttonTargetBlank?: boolean;
  onButtonClick?: () => void;
  hideButton?: boolean;
  status?: 'info' | 'warning' | 'success' | 'error';
}

export const NotConfiguredSection = ({
  header,
  message,
  buttonText,
  buttonLink,
  buttonTargetBlank = false,
  onButtonClick,
  hideButton = false,
  status = 'info',
}: NotConfiguredSectionProps) => (
  <VStack alignItems="start" spacing={2}>
    {header}
    <Alert status={status} variant="subtle">
      <VStack alignItems="start">
        <Text>{message}</Text>
        {!hideButton && buttonText && buttonLink && (
          <Button
            variant="solid"
            colorScheme="blue"
            as={RouterLink}
            to={buttonLink}
            target={buttonTargetBlank ? '_blank' : undefined}
            onClick={onButtonClick}
          >
            {buttonText}
          </Button>
        )}
      </VStack>
    </Alert>
  </VStack>
);
